import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import Carousel from '../carousel/carousel.component';
import { useCitiesData }  from '../../domain/city/city.domain';
import ContentLoader from 'react-content-loader';
import Router from 'next/router';
import useResponsive from '../../../utils/responsive';


const CityCarousel = (props) => {

  const { title, type, paragraph } = props;  

  const { isMobile } = useResponsive();

  const [isClient, setIsClient] = useState(false)

  const { data: cities, isLoading: citiesLoading, error: citiesError } = useCitiesData();

  const responsive = {
      desktop: {
          breakpoint: { 
              max: 3000, 
              min: 1024 
          },
          items: 4,
      },
      mobile: {
          breakpoint: {
              max: 464,
              min: 0
          },
          items: 1,
      },
      tablet: {
          breakpoint: {
              max: 1024,
              min: 464
          },
          items: 2,
      }
  };  

  useEffect(() => {
    setIsClient(true);
  }, []);

  let containerWidth = 1500;
  let containerHeight = 400;
  let boxWidth = 400;
  let offset = 0;  

  const onCitySelect = (cityName) => { 
    Router.push(`/bookings?city=${cityName}`).then(() => window.scrollTo(0, 0));    
  };

  const onFindaSpaceClick = () => {
    Router.push('/bookings').then(() => window.scrollTo(0, 0));
  };

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
      return (
          <div className="carousel-button-group">
              <IconButton
                  id="city-carousel-back-button"
                  className="city-carousel-back-button" onClick={() => previous()}
                  aria-label="Back"                 
              >
                  <ArrowBack className="play-page-city-carousel-arrow-back-button" />
              </IconButton>

              <IconButton
                  id="city-carousel-next-button"
                  className="city-carousel-next-button" onClick={() => next()}
                  aria-label="Next"
              >
                  <ArrowForward className="play-page-city-carousel-arrow-next-button" />
              </IconButton>
          </div>
      );
  };  

  const renderCarouselItem = () => {    

    return _.map(cities, (city, index) => {
      const bookableSpace = Math.floor(_.get(city, 'bookableSpaces') / 10) * 10;
      const cityName = _.get(city, 'name');
      const hasNewBuildings = _.get(city, 'hasNewBuildings');

      return (

        <div className='city-carousel-inner' key={index}>

          <LazyLoadComponent>
            <div className='city-carousel-image-container'>
              <img
                src={_.get(city, 'images[0]')}
                alt={`City of ${cityName}`}
                width="100%"
                height="100%"               
                id={`${cityName}-carousel-button`}
                onClick={() => onCitySelect(cityName)}
                className='city-carousel-image'
              />
            </div>
          </LazyLoadComponent>

          <p className="city-name" style={{
              fontWeight: 'bold',              
              marginBottom: 5
            }}>
              {cityName}
          </p>

          <p style={{
              fontSize: 16,
              marginTop: 0
            }}>            
              Over {bookableSpace}+ spaces
          </p>

          {hasNewBuildings && <p className='city-carousel-label'>{_.upperCase('New Buildings')}</p>}
          
        </div>

      );

    });

  };

  const renderLandingCarousel = () => {
      if(!isClient) return null;
      return (

          <div className='main-grid-container'>

              <div className='main-grid-item main-grid-xs-3'>
                  <div className='city-carousel-landing-header-container'>
                      <h4 className='city-carousel-landing-h4'>
                          Where is HOMii
                      </h4>
                      <p className='city-carousel-landing-p'>
                          You can find one in every buzzing city centre from Jozi to Cape Town!
                      </p>                      
                      <Button
                          id="city-carousel-find-a-space-button"
                          className="green-button"
                          onClick={onFindaSpaceClick}
                      >
                          Find a Space
                      </Button>                      
                  </div>
              </div>

              <div className='main-grid-item main-grid-xs-9'>
                  <div className='city-carousel-landing-container'>
                      <Carousel
                        responsive={responsive}
                        showDots={false}
                        arrows={false}
                        slidesToSlide={1}
                        infinite={true}
                        draggable={false}
                        autoPlay={true}
                        customCarouselItemWidth={isMobile ? 264.609 : 401.969}
                        renderButtonGroupOutside={true}
                        customButtonGroup={<ButtonGroup />}
                      >
                        {renderCarouselItem()}
                      </Carousel> 
                  </div>
              </div>

          </div>
      );
  }  

  const renderFindaSpaceCarousel = () => {
    if(!isClient) return null;
    return (

      <div id="city-carousel-find-a-space-page">

        <div className='city-carousel-wrapper'>

            <div>
              <h4 className='city-carousel-find-a-space-header'>
                  {title}
              </h4>

              <p  style={{
                marginTop: 24,
                marginBottom: 24,
                color: '#A2A2A2'
              }}
              >
                  {paragraph}
              </p>
            </div>
            
            <Carousel                  
              responsive={responsive}
              showDots={false}
              arrows={false}
              slidesToSlide={1}
              infinite={true}
              draggable={false}
              autoPlay={true}
              customCarouselItemWidth={isMobile ? 264.609 : 401.969}
              renderButtonGroupOutside={true}
              customButtonGroup={<ButtonGroup />}
            >
              {renderCarouselItem()}

            </Carousel>            

        </div>
             
          
      </div>
    );
  };

  const renderCarouselLoading = () => {
      if(!isClient) return null;
      return (
        <>
          <div style={{ marginTop: 10 }}>
            <ContentLoader
                  width={containerWidth}
                  height={containerHeight}
                  viewBox={`0 0 ${containerWidth} ${containerHeight}`}
                  backgroundColor="#1E252C"
                  foregroundColor="#181D1F"
                  animate
            >
                  <rect x="12" y="58" rx="2" ry="2" width={boxWidth} height="260" />
                  <rect x="12" y="340" rx="2" ry="2" width="150" height="10" />

                  <rect x={462 - offset} y="57" rx="2" ry="2" width={boxWidth} height="260" />
                  <rect x={462 - offset} y="340" rx="2" ry="2" width="150" height="10" />

                  <rect x={912 - 2 * offset} y="56" rx="2" ry="2" width={boxWidth} height="260" />
                  <rect x={912 - 2 * offset} y="340" rx="2" ry="2" width="150" height="10" />

              </ContentLoader>
          </div>

        </>
      );
  };

  const renderCarousel =() => {    
    return (
      <>
        {type === 'Landing' ? renderLandingCarousel() : null}
        {type === 'FindaSpace' ? renderFindaSpaceCarousel() : null}
      </>
    );    

  };

  return (
    <>      
      {citiesLoading ? renderCarouselLoading() : renderCarousel()}
    </>
  );  

};

export default CityCarousel;

CityCarousel.propTypes = {
    cities: PropTypes.array,
    title: PropTypes.string,
    type: PropTypes.string,
    paragraph: PropTypes.string,
};